module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/tv-4f46fd76c447cbf053d81e3973df4d94.jpg";